module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-25.5332058e.png";